module.exports = __webpack_public_path__ + "img/iconebarra.16f61e4f.webp";